import {
  Checkbox,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  styled,
  Switch,
  Typography,
} from "@mui/material";
import React from "react";
import Header from "../Header";
import { format } from "date-fns";
import OptionContainer from "./OptionContainer";
import OptionButton from "./OptionButton";
import StyledMenuButton from "./StyledMenuButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useSelector } from "react-redux";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 48,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(22px)",
      color: "#1F2937",
      "& + .MuiSwitch-track": {
        backgroundColor: "#fff",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "#000",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#4B5563",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const PerformanceDashboardHeader = ({
  period,
  handlePeriodChange,
  propertyFilterLabel,
  allPropertyFilter,
  propertyFilterMenuAnchor,
  handlePropertyFilterMenuClose,
  handlePropertyFilterMenuOpen,
  toggleAllPropertyFilter,
  propertyFilterItemsTemp,
  handleSelectPropertyInFilter,
  toggleDoComparison,
}) => {
  const auth = useSelector((state) => state.auth);

  const subtitle = (() => {
    const formattedTodaysDate = format(new Date(), "MMMM dd");
    switch (period.toLowerCase()) {
      case "today":
        return "Metric to-date for " + formattedTodaysDate;
      case "mtd":
        return "Month-to-date metrics for " + formattedTodaysDate;
      case "ytd":
        return "Year-to-date metrics for " + formattedTodaysDate;
      default:
        return "";
    }
  })();

  return (
    <Stack>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Header title={"Group performance dashboard"} subtitle={subtitle} />

        {/* PROPERTY FILTER OPTION  */}
        <Stack direction={"row"} spacing={2}>
          <OptionContainer>
            <Stack direction={"row"} spacing={1} alignItems={"center"} px={0.5}>
              <IOSSwitch onClick={toggleDoComparison} />
              <Typography
                color={"#fff"}
                fontSize={"0.875rem"}
                fontWeight={600}
                sx={{ mr: 1 }}
              >
                Compare with last year
              </Typography>
            </Stack>
          </OptionContainer>
          <OptionContainer>
            {["Today", "MTD", "YTD"].map((item) => (
              <OptionButton
                text={item}
                selected={item === period}
                onClick={() => handlePeriodChange(item)}
              />
            ))}
          </OptionContainer>
          <StyledMenuButton
            variant="contained"
            onClick={handlePropertyFilterMenuOpen}
            endIcon={
              !propertyFilterMenuAnchor ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardArrowUpIcon />
              )
            }
          >
            <span
              style={{
                display: "block",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                flex: 1,
                textAlign: "left",
              }}
            >
              {propertyFilterLabel}
            </span>
          </StyledMenuButton>
        </Stack>
      </Stack>

      {/* PROPERTY FILTER MENU  */}
      <Menu
        anchorEl={propertyFilterMenuAnchor}
        open={!!propertyFilterMenuAnchor}
        onClose={handlePropertyFilterMenuClose}
      >
        <MenuItem onClick={toggleAllPropertyFilter} dense>
          <Checkbox checked={allPropertyFilter} />
          <ListItemText primary="All Properties" />
        </MenuItem>
        {auth.hotels
          .filter((hotel) => "active" === hotel.status.toLowerCase())
          .map((hotel) => (
            <MenuItem
              key={hotel.hotelId}
              onClick={() => handleSelectPropertyInFilter(hotel.hotelId)}
              dense
            >
              <Checkbox
                checked={propertyFilterItemsTemp.includes(hotel.hotelId)}
              />
              <ListItemText primary={hotel.hotelName} />
            </MenuItem>
          ))}
      </Menu>
    </Stack>
  );
};

export default PerformanceDashboardHeader;
